(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rita-wood-header"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const categories = document.querySelectorAll('.mega-menu__category')
  const collections = document.querySelectorAll('.mega-menu__collections')
  const image = document.getElementById('megaMenuImage')

  categories.forEach(cat => {
    cat.addEventListener('mouseenter', () => {
      const index = cat.dataset.index

      categories.forEach(c => c.classList.remove('is-active'))
      cat.classList.add('is-active')

      collections.forEach(col => {
        col.classList.remove('active')

        if (col.dataset.index === index) {
          col.classList.add('active')

          const firstItem = col.querySelector('li')
          if (firstItem && firstItem.dataset.image) {
            image.src = firstItem.dataset.image
          }
        }
      })
    })
  })

  document.querySelectorAll('.mega-menu__collections li').forEach(item => {
    item.addEventListener('mouseenter', () => {
      if (item.dataset.image) {
        image.src = item.dataset.image
      }
    })
  })
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ritavo-wood-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__rvcoDone) return;
  window.__rvcoDone = true;

 
  var GRID_CFG = [
    { lo: 0,    hi: 374,  def: 1, allow: [1] },
    { lo: 375,  hi: 733,  def: 1, allow: [1] },
    { lo: 734,  hi: 767,  def: 1, allow: [1, 2] },
    { lo: 768,  hi: 903,  def: 2, allow: [1, 2] },
    { lo: 904,  hi: 1279, def: 2, allow: [1, 2, 3] },
    { lo: 1280, hi: 1599, def: 3, allow: [2, 3] },
    { lo: 1600, hi: 1919, def: 3, allow: [2, 3, 4] },
    { lo: 1920, hi: Infinity, def: 4, allow: [2, 3, 4] }
  ];

  function getCfg(w) {
    for (var i = 0; i < GRID_CFG.length; i++) {
      if (w >= GRID_CFG[i].lo && w <= GRID_CFG[i].hi) return GRID_CFG[i];
    }
    return GRID_CFG[GRID_CFG.length - 1];
  }


  var DESKTOP_OPEN_MIN = 1280;

 
  function fmtPrice(raw) {
    var vnd = Math.round(raw / 100);
    return new Intl.NumberFormat('vi-VN').format(vnd) + ' ₫';
  }

 
  document.addEventListener('DOMContentLoaded', function () {
    var page       = document.querySelector('[data-rvco]');
    if (!page) return;

  
    (function () {
      var cats      = page.querySelector('[data-rvco-cats]');
      var sentinel  = page.querySelector('[data-rvco-cats-sentinel]');
      if (!cats || !sentinel) return;

     
      var placeholder = document.createElement('div');
      placeholder.className = 'rvco-cats__placeholder';
      cats.parentNode.insertBefore(placeholder, cats);

      var isSticky = false;

      function makeSticky() {
        if (isSticky) return;
        isSticky = true;
        placeholder.style.height = cats.offsetHeight + 'px';
        placeholder.classList.add('is-visible');
        cats.classList.add('is-sticky');
      }

      function releaseSticky() {
        if (!isSticky) return;
        isSticky = false;
        placeholder.classList.remove('is-visible');
        cats.classList.remove('is-sticky');
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              releaseSticky();
            } else {
              
              if (entry.boundingClientRect.top < 0) {
                makeSticky();
              } else {
                releaseSticky();
              }
            }
          });
        },
        { threshold: 0, rootMargin: '0px 0px 0px 0px' }
      );

      observer.observe(sentinel);

      
      function initDragScroll(track) {
        var isDown     = false;
        var startX     = 0;
        var scrollLeft = 0;
        var moved      = false;

        track.style.cursor = 'grab';

       
        track.addEventListener('dragstart', function (e) { e.preventDefault(); });

        track.addEventListener('mousedown', function (e) {
          isDown     = true;
          moved      = false;
          startX     = e.pageX - track.offsetLeft;
          scrollLeft = track.scrollLeft;
          track.style.cursor = 'grabbing';
          track.style.userSelect = 'none';
     
          if (e.target.closest('a, img')) e.preventDefault();
        });

        document.addEventListener('mouseup', function () {
          if (!isDown) return;
          isDown = false;
          track.style.cursor = 'grab';
          track.style.userSelect = '';
        });

        document.addEventListener('mousemove', function (e) {
          if (!isDown) return;
          e.preventDefault();
          var x    = e.pageX - track.offsetLeft;
          var walk = (x - startX) * 1.2;
          if (Math.abs(walk) > 5) moved = true;
          track.scrollLeft = scrollLeft - walk;
        });

       
        track.addEventListener('click', function (e) {
          if (moved) {
            e.preventDefault();
            e.stopPropagation();
          }
        }, true);
      }

      page.querySelectorAll('.rvco-cats__track, .rvco-cats__track_child').forEach(initDragScroll);
    })();

    var sidebar    = page.querySelector('[data-rvco-sidebar]');
    var backdrop   = page.querySelector('[data-rvco-backdrop]');
    var toolbarLeft = page.querySelector('.rvco-toolbar__left');
    var gridEl     = page.querySelector('[data-rvco-grid]');
    var gridIcons  = page.querySelectorAll('[data-rvco-gi]');
    var sortSel    = page.querySelector('[data-rvco-sort]');
    var filterForm = page.querySelector('[data-rvco-filter-form]');
    var hideTexts  = page.querySelectorAll('[data-rvco-hide-text]');

    if (!sidebar) return;

    var activeCols = null;

   
    function isMobile() { return window.innerWidth < 1280; } 

    function sidebarIsOpen() {
      return !sidebar.classList.contains('is-closed');
    }

    function openSidebar() {
      sidebar.classList.remove('is-closed');
      sidebar.classList.add('is-open');
      if (toolbarLeft) {
        toolbarLeft.classList.remove('is-closed');
        toolbarLeft.classList.add('is-open');
      }
      if (isMobile()) {
        backdrop.classList.add('is-visible');
        document.body.style.overflow = 'hidden';
      }
      updateHideText();
    }

    function closeSidebar() {
      sidebar.classList.add('is-closed');
      sidebar.classList.remove('is-open');
      if (toolbarLeft) {
        toolbarLeft.classList.add('is-closed');
        toolbarLeft.classList.remove('is-open');
      }
      backdrop.classList.remove('is-visible');
      document.body.style.overflow = '';
      updateHideText();
    }

    function toggleSidebar() {
      if (sidebarIsOpen()) { closeSidebar(); } else { openSidebar(); }
    }

  function updateHideText() {
  var open = sidebarIsOpen();

  hideTexts.forEach(function (el) {
    var textEl = el.querySelector('.text');
    if (textEl) {
      textEl.textContent = open ? 'Ẩn bộ lọc' : 'Hiện bộ lọc';
    }
    el.classList.toggle('da-an', !open);
  });
}

  
    document.documentElement.classList.add('rv-no-trans');
    if (window.innerWidth >= DESKTOP_OPEN_MIN) {
      openSidebar();
    } else {
      closeSidebar();
    }
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        document.documentElement.classList.remove('rv-no-trans');
      });
    });

 
    page.querySelectorAll('[data-rvco-sb-toggle]').forEach(function (btn) {
      btn.addEventListener('click', toggleSidebar);
    });

  
    var closeBtn = page.querySelector('[data-rvco-sb-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', closeSidebar);
    }

  
    backdrop.addEventListener('click', closeSidebar);

    
    function setGrid(cols) {
      activeCols = cols;
      if (gridEl) { gridEl.setAttribute('data-cols', cols); }
      gridIcons.forEach(function (btn) {
        var c = parseInt(btn.getAttribute('data-rvco-gi'), 10);
        btn.classList.toggle('is-active', c === cols);
      });
    }

    function applyBreakpointGrid(cfg) {
      gridIcons.forEach(function (btn) {
        var c = parseInt(btn.getAttribute('data-rvco-gi'), 10);
        btn.style.display = cfg.allow.indexOf(c) > -1 ? '' : 'none';
      });
      var cur = activeCols || cfg.def;
      if (cfg.allow.indexOf(cur) === -1) {
        cur = cfg.def;
      }
      setGrid(cur);
    }

    gridIcons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var c = parseInt(btn.getAttribute('data-rvco-gi'), 10);
        setGrid(c);
      });
    });

    applyBreakpointGrid(getCfg(window.innerWidth));

   
    if (sortSel) {
      sortSel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSel.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

   
    
    function isMobileFilter() {
      return window.innerWidth <= 767;
    }

    function doSubmitFilter() {
      if (filterForm) { filterForm.submit(); }
    }

    if (filterForm) {
      filterForm.querySelectorAll('[data-rvco-fchk]').forEach(function (chk) {
        chk.addEventListener('change', function () {
          if (!isMobileFilter()) { doSubmitFilter(); }
          /* Mobile: chỉ update visual, không submit */
        });
      });
    }

    /* Nút Áp dụng bộ lọc (mobile) */
    var applyBtn = page.querySelector('[data-rvco-mobile-apply]');
    if (applyBtn) {
      applyBtn.addEventListener('click', function () {
        doSubmitFilter();
      });
    }

    /* Nút Đặt lại bộ lọc (mobile) */
    var resetBtn = page.querySelector('[data-rvco-mobile-reset]');
    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        var sortVal = (new URLSearchParams(window.location.search)).get('sort_by');
        var newUrl  = new URL(window.location.pathname, window.location.origin);
        if (sortVal) { newUrl.searchParams.set('sort_by', sortVal); }
        window.location.href = newUrl.toString();
      });
    }

    
    page.querySelectorAll('[data-rvco-price]').forEach(function (wrap) {
      var rangeMin  = wrap.querySelector('[data-rvco-p-min]');
      var rangeMax  = wrap.querySelector('[data-rvco-p-max]');
      var fill      = wrap.querySelector('[data-rvco-p-fill]');
      var inputFrom = wrap.querySelector('[data-rvco-p-from]');
      var inputTo   = wrap.querySelector('[data-rvco-p-to]');
      var pTotal    = parseFloat(wrap.getAttribute('data-pmax')) || 1;
      var GAP       = Math.max(pTotal * 0.005, 1000);

      if (!rangeMin || !rangeMax) { return; }

     
      var urlParams = new URLSearchParams(window.location.search);
      var urlGte    = urlParams.get(rangeMin.name);
      var urlLte    = urlParams.get(rangeMax.name);
      if (urlGte !== null && urlGte !== '') { rangeMin.value = parseFloat(urlGte); }
      if (urlLte !== null && urlLte !== '') { rangeMax.value = parseFloat(urlLte); }

      
      function fmt(n) {
        return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      }

    
      function parse(str) {
        if (!str) { return 0; }
        return parseFloat(String(str).replace(/\./g, '').replace(/,/g, '')) || 0;
      }

      function updateSlider() {
        var lo    = parseFloat(rangeMin.value);
        var hi    = parseFloat(rangeMax.value);
        var pctLo = (lo / pTotal) * 100;
        var pctHi = (hi / pTotal) * 100;
        if (fill) {
          fill.style.left  = pctLo + '%';
          fill.style.width = (pctHi - pctLo) + '%';
        }
        if (lo >= pTotal - GAP * 2) {
          rangeMin.style.zIndex = '5';
          rangeMax.style.zIndex = '4';
        } else {
          rangeMin.style.zIndex = '4';
          rangeMax.style.zIndex = '5';
        }
      }

      function updateInputsFromSlider() {
        if (inputFrom) { inputFrom.value = fmt(rangeMin.value); }
        if (inputTo)   { inputTo.value   = fmt(rangeMax.value); }
      }

      var priceTimer = null;
      function scheduleSubmit() {
        if (isMobileFilter()) { return; }
        clearTimeout(priceTimer);
        priceTimer = setTimeout(function () {
          if (filterForm) { filterForm.submit(); }
        }, 600);
      }

      rangeMin.addEventListener('input', function () {
        var lo = parseFloat(rangeMin.value);
        var hi = parseFloat(rangeMax.value);
        if (lo > hi - GAP) { rangeMin.value = hi - GAP; }
        updateSlider();
        updateInputsFromSlider();
        scheduleSubmit();
      });

      rangeMax.addEventListener('input', function () {
        var lo = parseFloat(rangeMin.value);
        var hi = parseFloat(rangeMax.value);
        if (hi < lo + GAP) { rangeMax.value = lo + GAP; }
        updateSlider();
        updateInputsFromSlider();
        scheduleSubmit();
      });

      function applyFromInput() {
        var lo = parse(inputFrom ? inputFrom.value : '0');
        var hi = parse(inputTo   ? inputTo.value   : String(pTotal));
        lo = Math.max(0, Math.min(lo, pTotal));
        hi = Math.max(0, Math.min(hi, pTotal));
        if (lo > hi - GAP) { lo = Math.max(0, hi - GAP); }
        rangeMin.value = lo;
        rangeMax.value = hi;
        if (inputFrom) { inputFrom.value = fmt(lo); }
        if (inputTo)   { inputTo.value   = fmt(hi); }
        updateSlider();
        if (!isMobileFilter()) {
          if (filterForm) { filterForm.submit(); }
        }
      }

      if (inputFrom) {
        inputFrom.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') { e.preventDefault(); applyFromInput(); }
        });
        inputFrom.addEventListener('focus', function () {
          inputFrom.value = parse(inputFrom.value) || '';
        });
        inputFrom.addEventListener('blur', applyFromInput);
      }

      if (inputTo) {
        inputTo.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') { e.preventDefault(); applyFromInput(); }
        });
        inputTo.addEventListener('focus', function () {
          inputTo.value = parse(inputTo.value) || '';
        });
        inputTo.addEventListener('blur', applyFromInput);
      }

   
      updateSlider();
    });

   
   page.querySelectorAll('[data-rvco-fg]').forEach(function (fg) {
  fg.setAttribute('data-open', 'true');
  });

    page.querySelectorAll('[data-rvco-fg-head]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'true'); 

      btn.addEventListener('click', function () {
        var fg   = btn.closest('[data-rvco-fg]');
        var open = fg.getAttribute('data-open') === 'true';

        fg.setAttribute('data-open', open ? 'false' : 'true');
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });

   
    var resizeTimer = null;
    var lastW = window.innerWidth;

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var w = window.innerWidth;
        if (w === lastW) return;
        lastW = w;

        applyBreakpointGrid(getCfg(w));

        if (w >= DESKTOP_OPEN_MIN) {
          backdrop.classList.remove('is-visible');
          document.body.style.overflow = '';
        } else {
          if (sidebarIsOpen() && !isMobile()) {
            /* tablet: */
          }
          if (w < 768 && sidebarIsOpen()) {
            backdrop.classList.add('is-visible');
            document.body.style.overflow = 'hidden';
          }
        }
      }, 150);
    });

  });

   










})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ritavo-wood-gioi-thieu-conso"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var els = document.querySelectorAll('[data-counter-target]');
    if (!els.length) return;
    var done = new WeakSet();
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting && !done.has(e.target)) {
          done.add(e.target);
          var el = e.target;
          var target = parseInt(el.dataset.counterTarget, 10) || 0;
          var suffix = el.dataset.counterSuffix || '';
          var dur = 1500;
          var start = performance.now();
          (function tick(now){
            var p = Math.min((now - start) / dur, 1);
            var ease = 1 - Math.pow(1 - p, 3);
            el.textContent = Math.round(ease * target) + suffix;
            if (p < 1) requestAnimationFrame(tick);
          })(start);
        }
      });
    }, {threshold: 0.3});
    els.forEach(function(el){ io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ritavo-wood-product-detail"]) return;
  try {
    
(function () {
  if (window.__rvcoDone) return;
  window.__rvcoDone = true;
  const header = document.querySelector('.rv-header');
    const currentPath = window.location.pathname.replace(/\/$/, '');
    document.querySelectorAll('.rvco-cats__item').forEach(function (item) {
      const link = item.querySelector('a[href]');
      if (!link) { return; }
      const linkPath = link.getAttribute('href').split('?')[0].replace(/\/$/, '');
      if (linkPath && linkPath === currentPath) {
        item.classList.add('active');
      }
    });
    if (!header) { return; }

    let ticking = false;

    window.addEventListener('scroll', function () {
      if (ticking) { return; }
      ticking = true;
      requestAnimationFrame(function () {
        if (window.scrollY > 120) {
          header.classList.add('dangcuonxuong');
        } else {
          header.classList.remove('dangcuonxuong');
        }
        ticking = false;
      });
    }, { passive: true });



document.addEventListener('DOMContentLoaded', function () {
  const buttons_tab = document.querySelectorAll('.rv-tab-btn');
  const panels_tab = document.querySelectorAll('.rv-tab-panel');

  buttons_tab.forEach(btn => {
    btn.addEventListener('click', () => {
      const target = btn.getAttribute('data-tab');
      buttons_tab.forEach(b => b.classList.remove('is-active'));
      panels_tab.forEach(p => p.classList.remove('is-active'));
      btn.classList.add('is-active');
      document.getElementById(target).classList.add('is-active');
    });
  });
});

 var overlay      = document.getElementById('rv-popup-overlay');
  var popupBody    = document.getElementById('rv-popup-body');
  var closeBtn     = document.getElementById('rv-popup-close');
  var downloadBtn  = document.getElementById('rv-popup-download');
  var pdfDataEl    = document.getElementById('rv-popup-pdf-data');

  if (!overlay || !popupBody) return;

  var pdfData = {};
  try { pdfData = JSON.parse(pdfDataEl.textContent); } catch (_) {}

  function openPopup(key) {
    var tpl = document.getElementById('rv-tpl-' + key);
    if (!tpl) return;

    popupBody.innerHTML = tpl.innerHTML;

    
    var pdf = pdfData[key];
    if (downloadBtn) {
      if (pdf) {
        downloadBtn.href = pdf;
        downloadBtn.hidden = false;
      } else {
        downloadBtn.hidden = true;
      }
    }

    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closePopup() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.rv-moxemthem');
    if (btn) { openPopup(btn.dataset.popup); return; }
    if (e.target === overlay) closePopup();
  });

  if (closeBtn) closeBtn.addEventListener('click', closePopup);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closePopup();
  });

document.addEventListener('DOMContentLoaded', () => {
    const gallery = document.querySelector('.wt-product__gallery--sticky');
    const info = document.querySelector('.wt-product__info');

    if (!gallery || !info) return;

   
    const sentinel = document.createElement('div');
    sentinel.style.position = 'absolute';
    sentinel.style.bottom = '0';
    sentinel.style.height = '1px';
    sentinel.style.width = '100%';

    gallery.style.position = 'relative';
    gallery.appendChild(sentinel);

    const observer = new IntersectionObserver(
        ([entry]) => {
            if (entry.isIntersecting) {
               
                info.classList.add('is-release');
            } else {
               
                info.classList.remove('is-release');
            }
        },
        {
            root: null,
            threshold: 0,
            rootMargin: '0px 0px -100% 0px'
        }
    );

    observer.observe(sentinel);
});
function injectMuaNgayIcon() {
    var btn = document.querySelector(
      '.wt-product__add-to-cart_form .shopify-payment-button__button--unbranded'
    );
    if (!btn || btn.dataset.muangayIcon) return;

    btn.dataset.muangayIcon = 'true';
    btn.style.cssText += 'display:inline-flex!important;align-items:center!important;justify-content:center!important;gap:8px!important;';

    var icon = document.createElement('span');
    icon.className = 'muangay-icon';
    icon.style.cssText = 'display:flex;align-items:center;flex-shrink:0;';
    icon.innerHTML = '<svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M8.69436 0H12.8064C14.6444 0 16.1004 1.19209e-07 17.2394 0.153C18.4114 0.311 19.3604 0.643 20.1094 1.391C20.8574 2.14 21.1894 3.089 21.3474 4.261C21.4374 4.934 21.4744 5.717 21.4894 6.624C21.5018 6.70007 21.5031 6.77754 21.4934 6.854C21.4994 7.41933 21.5017 8.03267 21.5004 8.694V8.806C21.5004 10.644 21.5004 12.1 21.3474 13.239C21.1894 14.411 20.8574 15.36 20.1094 16.109C19.3604 16.857 18.4114 17.189 17.2394 17.347C16.0994 17.5 14.6444 17.5 12.8064 17.5H8.69436C6.85636 17.5 5.40036 17.5 4.26136 17.347C3.08936 17.189 2.14036 16.857 1.39136 16.109C0.643364 15.36 0.311364 14.411 0.153364 13.239C0.000363633 12.099 0.000363639 10.644 0.000363639 8.806V8.694C-0.000969694 8.03267 0.00136361 7.41933 0.00736361 6.854C-0.00272093 6.77759 -0.00171047 6.70012 0.0103636 6.624C0.0263636 5.717 0.0633636 4.934 0.153364 4.261C0.311364 3.089 0.643364 2.14 1.39136 1.391C2.14036 0.643 3.08936 0.311 4.26136 0.153C5.40136 1.19209e-07 6.85636 0 8.69436 0ZM1.50236 7.5C1.50103 7.888 1.50036 8.30467 1.50036 8.75C1.50036 10.657 1.50236 12.012 1.64036 13.04C1.77536 14.045 2.02936 14.625 2.45236 15.048C2.87536 15.471 3.45536 15.725 4.46136 15.86C5.48936 15.998 6.84336 16 8.75036 16H12.7504C14.6574 16 16.0124 15.998 17.0404 15.86C18.0454 15.725 18.6254 15.471 19.0484 15.048C19.4714 14.625 19.7254 14.045 19.8604 13.039C19.9984 12.011 20.0004 10.657 20.0004 8.75C20.0004 8.30467 19.9997 7.888 19.9984 7.5H1.50236ZM19.9744 6H1.52636C1.54636 5.413 1.58036 4.906 1.64036 4.46C1.77536 3.455 2.02936 2.875 2.45236 2.452C2.87536 2.029 3.45536 1.775 4.46136 1.64C5.48936 1.502 6.84336 1.5 8.75036 1.5H12.7504C14.6574 1.5 16.0124 1.502 17.0404 1.64C18.0454 1.775 18.6254 2.029 19.0484 2.452C19.4714 2.875 19.7254 3.455 19.8604 4.461C19.9204 4.906 19.9544 5.413 19.9744 6ZM4.00036 12.75C4.00036 12.5511 4.07938 12.3603 4.22003 12.2197C4.36069 12.079 4.55145 12 4.75036 12H8.75036C8.94928 12 9.14004 12.079 9.28069 12.2197C9.42134 12.3603 9.50036 12.5511 9.50036 12.75C9.50036 12.9489 9.42134 13.1397 9.28069 13.2803C9.14004 13.421 8.94928 13.5 8.75036 13.5H4.75036C4.55145 13.5 4.36069 13.421 4.22003 13.2803C4.07938 13.1397 4.00036 12.9489 4.00036 12.75ZM10.5004 12.75C10.5004 12.5511 10.5794 12.3603 10.72 12.2197C10.8607 12.079 11.0514 12 11.2504 12H12.7504C12.9493 12 13.14 12.079 13.2807 12.2197C13.4213 12.3603 13.5004 12.5511 13.5004 12.75C13.5004 12.9489 13.4213 13.1397 13.2807 13.2803C13.14 13.421 12.9493 13.5 12.7504 13.5H11.2504C11.0514 13.5 10.8607 13.421 10.72 13.2803C10.5794 13.1397 10.5004 12.9489 10.5004 12.75Z" fill="#FAFAFA"/> </svg>';

    btn.insertBefore(icon, btn.firstChild);
  }

  injectMuaNgayIcon();

  var muangayWrap = document.querySelector('.muangay-wrap');
  if (muangayWrap) {
    var muangayObserver = new MutationObserver(function () {
      injectMuaNgayIcon();
    });
    muangayObserver.observe(muangayWrap, { childList: true, subtree: true });
  }


})();
(function () {
  function syncDecreaseClass(counter) {
    var input = counter.querySelector('.js-counter-quantity');
    var btn   = counter.querySelector('.js-counter-decrease');
    if (!input || !btn) return;
    btn.classList.toggle('khonggiam', parseInt(input.value, 10) <= 1);
  }

  document.querySelectorAll('quantity-counter').forEach(function (counter) {
    syncDecreaseClass(counter);

    counter.querySelector('.js-counter-quantity')?.addEventListener('input', function () {
      syncDecreaseClass(counter);
    });

    counter.querySelector('.js-counter-decrease')?.addEventListener('click', function () {
      setTimeout(function () { syncDecreaseClass(counter); }, 0);
    });

    counter.querySelector('.js-counter-increase')?.addEventListener('click', function () {
      setTimeout(function () { syncDecreaseClass(counter); }, 0);
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
